import SettingsFieldTitle from '../../SettingsFieldTitle';
import UploadBox from './UploadBox';
import { FormattedMessage } from 'react-intl';

type LogoUploadSectionProps = {
  logoAsDataUrl: string;
  onSetLogoFiles: (files: File[]) => void;
};

const LogoUploadSection = ({
  logoAsDataUrl,
  onSetLogoFiles,
}: LogoUploadSectionProps) => (
  <>
    <SettingsFieldTitle>
      <FormattedMessage id="platform_settings.general_settings.logo_upload.title" />
    </SettingsFieldTitle>
    <UploadBox preview={logoAsDataUrl} onDrop={onSetLogoFiles}>
      <FormattedMessage id="platform_settings.general_settings.logo_upload.box_label" />
    </UploadBox>
  </>
);

export default LogoUploadSection;
